/**
 * Cor do swatch: CorHex do produto (API) → mapa por variante na família → fallback local.
 * @param {string} [corHexDirect] — ex.: item do carrinho com corHex do SKU
 */
export function getPreviewColorHex(colorName, fam, corHexDirect) {
  const direct = (corHexDirect || "").trim();
  if (direct) return direct;
  const key = (colorName || "").trim();
  if (!key) return "#cbd5e1";
  const fromApi = fam?.variantColorHex?.[key];
  if (fromApi) return fromApi;
  return FALLBACK_COLOR_HEX[key] || "#94a3b8";
}

const FALLBACK_COLOR_HEX = {
  Branco: "#FFFFFF",
  Bianco: "#FFFFFF",
  Verde: "#15803d",
  Marinho: "#1e3a5f",
  Bege: "#F5F5DC",
  Cinza: "#9ca3af",
  Azul: "#2563eb",
};
